import { DatePicker, Modal } from 'antd';
import DataGrid, { DataGridColDef } from 'components/DataGrid/DataGrid';
import {
  findPaymentByAnyRefOrStatusOrDate,
  PAYListResponse,
} from 'services/PaymentServices';
import React, { useMemo, useState } from 'react';
import ModalControllerNV from 'components/ModalControllerNV';
import PayementModal from '../PayementModal';
import ParListSelect from 'components/ParListSelect';
import { toCurrency } from 'utils/utils';
import CIDetail from 'pages/ClientInvoice/CIDetail';
import SIDetail from 'pages/SupplierInvoice/SIDetail';
import SIStatusTag from 'pages/SupplierInvoice/SIStatusTag';
import moment from 'moment';
import { dateToString } from 'utils/utils2';
import { useQuery } from 'react-query';

export type PayRepresentmentListModalProps = {
  isModal?: string;
  onSelect?: any;
  hideCIListModal?: () => void;
  hideCol?: boolean;
  hideExtraAction?: boolean;
  visible: boolean;
  onCancel: any;
  selectedRowKeys: PAYListResponse[];
};

const PayRepresentmentListModal = ({
  onSelect,
  visible,
  onCancel,
  selectedRowKeys,
}: PayRepresentmentListModalProps) => {
  const initialSearchValues = {
    cireference: '',
    ctreference: '',
    datemax: '',
    datemin: '',
    payallstat: '',
    paydocreference: '',
    paymode: 'DDEBIT',
    payreference: '',
    paystatus: 'REJECT',
    sireference: '',
    tpname: '',
    tpreference: '',
    paydirection: 'IN',
    currcode: '',
    paytype: 'PAY',
    flagFilters: false,
    duedate: moment(),
    tpbankaccount: 0,
    tpidend: 0,
    tpidstart: 0,
    mgid: 1,
  };

  const [searchs, setsearchs] = useState(false);

  const [searchParams, setSearchParams] = useState<any>(initialSearchValues);

  const [selectedFile, setSelectedFile] = useState<
    PAYListResponse[] | undefined
  >(selectedRowKeys);

  const { data, refetch, isFetching } = useQuery(
    ['findPaymentByAnyRefOrStatusOrDate', searchParams],
    () =>
      findPaymentByAnyRefOrStatusOrDate(searchParams).then((res) => {
        return res.list || [];
      })
  );

  const columnsList = useMemo<DataGridColDef<PAYListResponse>[]>(
    () => [
      {
        dataIndex: 'payreference',
        width: 80,
        fixed: 'left',
        filtrable: true,
        render: (value, record) => (
          <ModalControllerNV
            modal={({ setVisible, visible }) => (
              <PayementModal
                payid={record.payid}
                showAsModal
                hideButtons
                visible={visible}
                onCancel={() => setVisible(false)}
                onSuccess={() => setVisible(false)}
              />
            )}
            content={({ setVisible, visible }) => (
              <a onClick={() => setVisible(true)}>{value}</a>
            )}
          />
        ),
      },
      {
        dataIndex: 'tpname',
        filtrable: true,
        width: 120,
      },
      {
        dataIndex: 'payamount',
        filtrable: 'currcode',
        filterComponent: <ParListSelect parcode="CURRENCY" />,
        width: 120,
        render: (val, record) => toCurrency(val, record.currcode ?? localStorage.getItem('currcode') ?? ''),
      },

      {
        dataIndex: 'payremainingamount',

        width: 120,
        render: (val, record) => toCurrency(val, record.currcode ?? localStorage.getItem('currcode') ?? ''),
      },
      {
        comcode: 'InvoiceRef',
        dataIndex: 'cireference',
        filtrable: true,

        width: 120,
        render: (value, record) => (
          <>
            {record.cireference && record.ciid && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.cireference}</a>
                )}
                modal={({ setVisible, visible }) => (
                  <CIDetail
                    ciid={record.ciid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}
            {record.sireference && record.siid && (
              <ModalControllerNV
                content={({ setVisible, visible }) => (
                  <a onClick={() => setVisible(true)}>{record.sireference}</a>
                )}
                modal={({ setVisible, visible }) => (
                  <SIDetail
                    siid={record.siid}
                    onCancel={() => setVisible(false)}
                    showAsModal
                    visible={visible}
                  />
                )}
              />
            )}{' '}
            {(record.siid === null || record.siid === 0) && 
              (record.ciid === null || record.ciid === 0) && 
              value}
          </>
        ),
      },
      {
        dataIndex: 'ctreference',
        filtrable: true,

        width: 120,
      },
      {
        dataIndex: 'paydocdate',
        comcode: 'paydocdate',
        filtrable: 'datemin',
        filterComponent: (
          <DatePicker
            value={searchParams.datemin}
            onChange={(date: any, dateString: string) => {
              searchParams.datemin = dateString;
            }}
            name="datemin"
            placeholder="date min"
            allowClear
          />
        ),
        width: 120,
        render: (e) => moment(e).format('YYYY-MM-DD'),
      },
      {
        dataIndex: 'paynbrepresentation',
        width: 120,
      },
      {
        comcode: 'paystatuslabel',
        dataIndex: 'paystatus',
        width: 120,
        filtrable: 'datemax',
        filterComponent: (
          <DatePicker
            value={searchParams.datemax}
            onChange={(date: any, dateString: string) => {
              searchParams.datemax = dateString;
            }}
            name="datemax"
            placeholder="date max"
            allowClear
          />
        ),
        render: (value, record) => (
          <SIStatusTag
            status={record.paystatus}
            statuslabel={record.statuslabel}
            key={record.payid}
          />
        ),
      },
    ],
    []
  );

  const rowSelection = {
    onChange: (selectedRowKeys: any, selectedRows: any) => {
      setSelectedFile(selectedRows);
    },
    // onSelect: (record: any, selected: any, selectedRows: any) => {
    //
    //     setSelectedFile(selectedRows);
    // },
    onSelectAll: (selected: any, selectedRows: any, changeRows: any) => {
      setSelectedFile(selectedRows);
    },
    selectedRowKeys: selectedFile?.map((file) => file.payid),
    // hideSelectAll: true,
  };

  return (
    <Modal
      visible={visible}
      onCancel={onCancel}
      width={1200}
      destroyOnClose
      onOk={() => {
        onSelect(selectedFile);
      }}
      okText="Select"
    >
      <DataGrid
        rowKey="payid"
        dataSource={searchParams.flagFilters ? [] : data}
        titleComcode="paymentrepresentement"
        columns={columnsList}
        onSearch={(value) => {
          setSearchParams({
            ...value,
            datemin: dateToString(value.datemin),
            datemax: dateToString(value.datemax),
            flagFilters: searchParams.flagFilters,
            currcode: value.currcode,
            duedate: value.duedate,
            mgid: value.mgid,
            tpbankaccount: value.tpbankaccount,
            tpidend: value.tpidend,
            tpidstart: value.tpidstart,
          });
          setsearchs(true);
        }}
        onClear={() => {
          setSearchParams({
            cireference: '',
            ctreference: '',
            datemax: '',
            datemin: '',
            payallstat: '',
            paydocreference: '',
            paymode: 'DDEBIT',
            payreference: '',
            paystatus: 'REJECT',
            sireference: '',
            tpname: '',
            tpreference: '',
            paydirection: 'IN',
            currcode: '',
            paytype: '',
            flagFilters: searchParams.flagFilters,
            duedate: '',
            tpbankaccount: 0,
            tpidend: 0,
            tpidstart: 0,
            mgid: 1,
          });
        }}
        initialSearchValues={initialSearchValues}
        isLoading={isFetching}
        rowSelection={rowSelection}
      />
    </Modal>
  );
};

export default PayRepresentmentListModal;
